// The boot module of the game page (i18n.md §1.1, R1429). The page's
// script is this module: it installs the boot error painter, loads the
// tables of a second language, and only then imports the application, so
// gen/strings.ts finds the tables loaded when it evaluates.
//
// It must import nothing else, because its chunk is the first the page
// runs. It holds no top-level await: in Rolldown's lazy module init an
// await makes every importer's init async (R1429). A fault of the load is
// an unhandled rejection, and the painter shows it.
import '../ui/booterror';
import { loadLanguage } from '../gen/strings.load';

void loadLanguage().then(() => import('./main'));
